import {
	IonApp,
	IonCol,
	IonContent,
	IonInfiniteScroll,
	IonInfiniteScrollContent,
	IonLoading,
	IonPage,
} from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import NavFooter from "components/mobile-components/Common/NavFooter";
import { getUserBusiness } from "config/user";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Product from "services/Product";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import TextInputWithIcon from "components/mobile-components/Common/TextInputWithIcon";
import { toast } from "react-toastify";
import Payment from "services/Payment";

export default function SalaryPayoutListPage() {
	const [loading, setLoading] = useState(true);
	const ekkLanguage = useSelector((state) => state.lan.lan);
	const [hasMoreData, setHasMoreData] = useState(true);
	const [reachedEnd, setReachedEnd] = useState(false);
	const [pageCount, setPageCount] = useState(2);
	const [salaryList, setSalaryList] = useState([]);
	const { id } = useParams();
	const dateFormat = useSelector((state) => state.date.format);
	const [employeeSalary, setEmployeeSalary] = useState([]);
	const business = getUserBusiness();
	const [salaryPayoutAmount, setSalaryPayoutAmount] = useState("");
	const [salaryPayoutAmountEmpty, setSalaryPayoutAmountEmpty] = useState("");
	const [payoutDescription, setPayoutDescription] = useState("");
	const [salaryPayoutLoader, setSalaryPayoutLoader] = useState(false);
	const [salaryPayoutId, setSalaryPayoutId] = useState(null);
	const [isOpenSalaryPayoutModel, setIsOpenSalaryPayoutModel] =
		useState(false);
	const onCloseSalaryPayoutModel = () => {
		setIsOpenSalaryPayoutModel(false);
	};

	const getEmployeesSalary = async () => {
		let response = await Product.getEmployeeSalary(id, business?.id);
		if (response.status === 200) {
			setEmployeeSalary(response.results);
		} else {
			setEmployeeSalary([]);
		}
	};

	const getSalaryPayoutList = async (id) => {
		setLoading(true);
		let response = await Product.getEmployeeSalaryList(id);
		if (response.status === 200) {
			setSalaryList(response.results);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	useEffect(() => {
		getSalaryPayoutList(id);
		getEmployeesSalary();
	}, []);

	let loadMoreData = async () => {
		if (hasMoreData) {
			let response = await Product.getEmployeeSalaryList(id, pageCount, 50);
			if (response.status === 200) {
				setPageCount((prev) => prev + 1);
				setSalaryList([...salaryList, ...response.results]);
			} else {
				setHasMoreData(false);
			}
		}
	};

	const salaryPayoutHandler = async () => {
		if (salaryPayoutAmount === "") {
			setSalaryPayoutAmountEmpty("Please enter amount");
			return;
		}
		setSalaryPayoutLoader(true);
		let payload = {
			amount: salaryPayoutAmount,
			description: payoutDescription,
		};

		let response = await Payment.updateSalaryPayout(salaryPayoutId, payload);
		if (response.success) {
			setSalaryPayoutLoader(false);
			toast.success("Salary payout updated successfully");
			onCloseSalaryPayoutModel();
			getSalaryPayoutList(id);
		} else {
			setSalaryPayoutLoader(false);
		}
	};

	return (
		<IonApp>
			<IonPage>
				<IonContent style={{ "--background": "#fff" }}>
					<BackButtonTitle title='Salary Payout List' />
					<section className='pt-14'>
						{loading ? (
							<IonLoading
								isOpen={true}
								message={ekkLanguage.orderList?.loader}></IonLoading>
						) : (
							<>
								<div>
									<div className='px-4 py-[10px]'>
										<div className='flex justify-between items-center mb-1'>
											<h4 className='font-bold text-16 text-black-1000'>
												Salary Type: {employeeSalary?.salary_type}
											</h4>
										</div>
										<div className='flex justify-between items-center mb-5'>
											<h4 className='font-bold text-16 text-black-1000'>
												Salary Amount: {employeeSalary?.amount}
											</h4>
										</div>

										<div className='mb-4'>
											<table className='table-auto w-full bg-white'>
												<thead>
													<tr className='border h-[45px] border-r-0 border-l-0 border-D9D9D9 px-4'>
														<th className='font-bold text-14'>
															Date
														</th>
														<th className='font-bold text-14'>
															Amount
														</th>
														<th className='font-bold text-14'>
															Paid By
														</th>
													</tr>
												</thead>

												<tbody>
													{salaryList?.length > 0 &&
														salaryList?.map((el, i) => (
															<tr
																key={i}
																className='text-center h-[34px] border border-r-0 border-l-0 border-D9D9D9 px-4'
																onClick={() => {
																	setSalaryPayoutId(el?.id);
																	setSalaryPayoutAmount(
																		Number(
																			el?.amount
																		).toFixed(2)
																	);
																	setPayoutDescription(
																		el?.description
																	);
																	setIsOpenSalaryPayoutModel(
																		true
																	);
																}}>
																<td className='font-semibold text-12'>
																	{moment(
																		el?.createdAt
																	).format(
																		`${dateFormat}-HH:mm:ss`
																	)}
																</td>
																<td className='font-semibold text-12'>
																	{Number(el?.amount).toFixed(
																		2
																	)}
																</td>
																<td className='font-semibold text-12'>
																	{el?.created_by_name}
																</td>
															</tr>
														))}
												</tbody>
											</table>

											{salaryList.length === 0 && (
												<>
													<IonCol size='2'></IonCol>
													<IonCol size='8'>
														<div
															className='text-center flex items-center justify-center'
															style={{
																height: "calc(100vh - 420px)",
															}}>
															<div>
																<img
																	className='m-auto mb-[10px] mt-5'
																	src='/assets/images/not-found-file.png'
																	alt='emptyCard'
																/>
																<p className='text-16 font-normal text-222222 mb-[35px]'>
																	{
																		ekkLanguage.orderList
																			.notFound
																	}
																</p>
															</div>
														</div>
													</IonCol>
												</>
											)}
										</div>
									</div>
								</div>
							</>
						)}
					</section>
					<IonInfiniteScroll
						onIonInfinite={(ev) => {
							if (reachedEnd) {
								ev.target.complete();
								return;
							}
							loadMoreData();
							setTimeout(() => {
								ev.target.complete();
								if (!hasMoreData) {
									setReachedEnd(true);
								}
							}, 1000);
						}}>
						<IonInfiniteScrollContent
							loadingText={ekkLanguage.orderList.loader}
							loadingSpinner={
								hasMoreData ? "bubbles" : null
							}></IonInfiniteScrollContent>
					</IonInfiniteScroll>
				</IonContent>
				{/* <NavFooter /> */}
			</IonPage>
			<Modal
				open={isOpenSalaryPayoutModel}
				onClose={onCloseSalaryPayoutModel}
				classNames='bottom-sheet-modal'>
				<div className='p-5'>
					<h6 className='text-16 font-bold pb-[10px]'>
						{" "}
						Update Salary Payout
					</h6>

					<div className='text-left'>
						<h5 className='text-dark-1000 text-16 mb-2 font-semibold'>
							Amount
						</h5>
						<TextInputWithIcon
							type='number'
							inputText={salaryPayoutAmount}
							setInputText={setSalaryPayoutAmount}
							placeholder={`Enter salary payout amount`}
						/>
						{salaryPayoutAmountEmpty && (
							<p className='text-red-500 text-12'>
								{salaryPayoutAmountEmpty}
							</p>
						)}
					</div>
					<div className='text-left'>
						<h5 className='text-dark-1000 text-16 mb-2 font-semibold'>
							Description
						</h5>

						<TextInputWithIcon
							type='text'
							inputText={payoutDescription}
							setInputText={setPayoutDescription}
							placeholder={`Enter payout description`}
						/>
					</div>
					<div className='text-left mb-4'>
						<p className='text-red-500 text-12'>
							**Expense record for this payout will auto updatee
						</p>
					</div>

					<div className='flex'>
						<button
							className='border-2 font-bold h-10 rounded-[7px] w-1/2 mr-2 border-solid bg-primary text-white'
							onClick={onCloseSalaryPayoutModel}>
							Cancel
						</button>
						<button
							color='success'
							className='font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white'
							onClick={!salaryPayoutLoader && salaryPayoutHandler}>
							{salaryPayoutLoader ? (
								<ClipLoader
									sizeUnit={"px"}
									size={20}
									color={"white"}
									loading={true}
								/>
							) : (
								"Update"
							)}
						</button>
					</div>
				</div>
			</Modal>
		</IonApp>
	);
}
